
import {Vue, Component, Prop} from "vue-property-decorator";

@Component({})
export default class BoxDeletingModal extends Vue {
    @Prop({default: false})
    public confirmBlock: boolean;
}
